import MintPage from "./pages/MintPage";


import './assets/styles/fonts.scss'
import './assets/styles/styles.scss'

function App() {
  return (
    <div>
      <MintPage />
    </div>
  );
}

export default App;
